

































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { backgroundColor } from '@/helper'
import Big from 'big.js'

@Component({
    components: {},
})
export default class AVAXBalanceTableDetail extends Vue {
    @Prop() pUnlocked!: Big
    @Prop() pLockedStakeable!: Big
    @Prop() pLockedNotStakeable!: Big
    @Prop() pStaked!: Big
    @Prop() xpUnlocked!: Big
    @Prop() xUnlocked!: Big
    @Prop() xLocked!: Big
    @Prop() xcUnlocked!: Big

    balances: any[] = [
        {
            name: 'Unlocked',
            chain: 'Platform',
            balance: this.pUnlocked,
        },
        {
            name: 'Locked (Stakeable)',
            chain: 'Platform',
            balance: this.pLockedStakeable,
        },
        {
            name: 'Locked (Not-Stakeable)',
            chain: 'Platform',
            balance: this.pLockedNotStakeable,
        },
        {
            name: 'Staked',
            chain: 'Platform',
            balance: this.pStaked,
        },
        {
            name: 'Unlocked',
            chain: 'XP Shared Memory',
            balance: this.xpUnlocked,
        },
        {
            name: 'Unlocked',
            chain: 'Exchange',
            balance: this.xUnlocked,
        },
        {
            name: 'Locked',
            chain: 'Exchange',
            balance: this.xLocked,
        },
        {
            name: 'Unlocked',
            chain: 'XC Shared Memory',
            balance: this.xcUnlocked,
        },
        {
            name: 'Total Balance',
            chain: '',
            balance: this.totalAVAX,
        },
    ]

    get totalAVAX(): Big {
        return this.pUnlocked
            .plus(this.pLockedStakeable)
            .plus(this.pLockedNotStakeable)
            .plus(this.pStaked)
            .plus(this.xpUnlocked)
            .plus(this.xUnlocked)
            .plus(this.xLocked)
            .plus(this.xcUnlocked)
    }

    background(chain: string): string {
        switch (chain) {
            case 'Platform':
                return backgroundColor('P')
            case 'XP Shared Memory':
                return backgroundColor('P')
            case 'Exchange':
                return backgroundColor('X')
            case 'XC Shared Memory':
                return backgroundColor('C')
            case 'Contract':
                return backgroundColor('C')
            default:
                return 'transparent'
        }
    }
}
